// IND-007: cargar maestros y ficheros diarios exige el permiso imports:manage.
import { useQuery } from '@tanstack/react-query';

import { getIndustrialCostContext } from '../services/industrialCostService';

export const IMPORT_PERMISSION_DENIED_TEXT =
  'Necesitas el permiso de importar datos; pídeselo a un administrador.';

/** true mientras no se sepa (el backend lo comprueba siempre). */
export function useCanManageImports(): boolean {
  const contextQuery = useQuery({
    queryKey: ['industrial-cost-context'],
    queryFn: getIndustrialCostContext,
    retry: false,
  });
  const permissions = contextQuery.data?.permissions;
  return permissions ? permissions.includes('imports:manage') : true;
}
